import axios from "../../../utils/axios";

export const getPosts = async (argument) => {
    const {sortBy, filterBy } = argument || {};
    
    let query= "";
    if(filterBy) query = `isSaved=${filterBy}&`
    if(sortBy) query +=  `_sort=${sortBy}&_order=desc`
    const response = await axios.get(`/blogs?${query}`);

    return response.data;
};